import React from "react";

import Loading from "../../../../../home/components/Loading";
import { Table } from "./components/Table";

export const LogsView = ({ item, isLoading, handlePageChange }) => {
  if (isLoading) return <Loading isLoading={isLoading} />;
  return (
    <>
      <Table.Root>
        <Table.Content>
          <Table.Head
            tableHeaders={["Responsável ", "Tipo", "Status", "Data de criação"]}
          />
          <Table.Body logsList={item?.data ?? []} />
        </Table.Content>

        <Table.Pagination
          count={item?.meta?.pageCount ?? 0}
          page={item?.meta?.page ?? 1}
          hasPreviousPage={item?.meta?.hasPreviousPage ?? false}
          hasNextPage={item?.meta?.hasNextPage ?? false}
          onChange={handlePageChange}
        />
      </Table.Root>
    </>
  );
};

export default LogsView;
